import { render, staticRenderFns } from "./IndicadoresMarketplace.vue?vue&type=template&id=913e6b38&lang=pug"
import script from "./IndicadoresMarketplace.vue?vue&type=script&lang=js"
export * from "./IndicadoresMarketplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports